export default function () {
  this.loadProducts()

  if (this.$route.params.tripId) {
    this.tripId = this.$route.params.tripId
  }
}
